import ProfileIcon from "../../assets/img/EventDashoardLogo/eventprofile.svg";
import ManageIcon from "../../assets/img/EventDashoardLogo/event.svg";
import ReportsIcon from "../../assets/img/EventDashoardLogo/reports.svg";
import ManageEvents from "../../revampPages/ManageEvents/ManageEvents";
import EventProfile from "../../revampPages/ManageEvents/EventProfile/EventProfile";
import Reports from "../../revampPages/ManageEvents/Reports/Reports";

const ManageEventsItems = [
    {
        path: "/manage-events",
        label: "Events",
        icon: ManageIcon,
        component: ManageEvents,
        matchPaths: [
            "/manage-events",
        ],
    },
    {
        path: "/event-profile",
        label: "Event Profiles",
        icon: ProfileIcon,
        component: EventProfile,
        matchPaths: [
            "/event-profile",
            "/event-profile/",
        ],
    },
    {
        path: "/reports",
        label: "Reports",
        icon: ReportsIcon,
        component: Reports,
          matchPaths: [
            "/reports",
        ],
    },
];

export default ManageEventsItems;